import Model, { DefaultType, MemberType } from '../../../../utils/Model';
import Contact from '@legacy-modules/metrics2/models/entities/organization/Contact';

export default class OrgUnitProperties extends Model<OrgUnitProperties> {
  orgKey: string;
  name: string;
  area: number | null | undefined;
  orgId: number | null | undefined;
  contact: Contact | null | undefined;
  orgType: string;

  constructor(source: unknown = null, shallow: boolean = false) {
    super();
    this.hydrateFrom(source, shallow, this.getDefaults(), this.getMembers());
  }

  getDefaults(): DefaultType<OrgUnitProperties> {
    return undefined;
  }

  getMembers(): MemberType<OrgUnitProperties> {
    return {
      contact: (src) => (src ? new Contact(src) : null),
    };
  }
}
